import axios from "axios";
import config from "../../../config";

const baseUrl = config.baseUrl;

const getParticipantesPO = async (municipio = null) => {
  const endpoint = "/api/financiero/participantes";
  const response = await axios.get(`${baseUrl}${endpoint}`, {
    params: municipio ? { municipio } : {}
  });
  return response.data;
};

const getMunicipiosPO = async (departamento = null) => {
  const endpoint = "/api/financiero/municipios";
  const response = await axios.get(`${baseUrl}${endpoint}`, {
    params: departamento ? { departamento } : {}
  });
  return response.data;
};

const getDepartamentosPO = async () => {
  const endpoint = "/api/financiero/departamentos";
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

const getProyectosPO = async () => {
  const endpoint = "/api/financiero/proyectos";
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

const getOrganizacionesPO = async () => {
  const endpoint = "/api/financiero/organizaciones";
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

const getResponsablesPO = async () => {
  const endpoint = "/api/financiero/responsables";
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

export {
  getParticipantesPO,
  getMunicipiosPO,
  getDepartamentosPO,
  getProyectosPO,
  getOrganizacionesPO,
  getResponsablesPO
};
